
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cart/add-sku/[id]",
      function () {
        return require("private-next-pages/cart/add-sku/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cart/add-sku/[id]"])
      });
    }
  